declare global {
    interface Array<T> {
        last(): T
        first(): T
        distinct(): T[]
    }
}

Array.prototype.last = function () {
    return this[this.length - 1]
}

Array.prototype.first = function () {
    return this[0]
}

const distinct = (value: any, index: number, array: any[]) =>
    array.indexOf(value) === index

Array.prototype.distinct = function() {
    return this.filter(distinct)
}

export {}
